import {
  hopperFlashSaleApi,
  SubscribeToSaleRequest,
  SubscribeUserToSaleResponse,
} from "@b2bportal/hopper-flash-sale-api";
import { axiosInstance } from "@hopper-b2b/api";

export const subscribeToSale = async (
  request: SubscribeToSaleRequest
): Promise<SubscribeUserToSaleResponse> => {
  return new Promise((resolve, reject) => {
    try {
      hopperFlashSaleApi(axiosInstance)
        .apiV0FlashSalePublishedSaleSubscribePost(request)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
};
